import React, {FC, useState} from 'react'
import {BaseModal} from '../../../../components/Modals/BaseModal/BaseModal' // Ajuste o nível de pastas conforme seu projeto
import {Input} from '../../../../components/Input/Input'

export type EntertainmentItem = {
  id: number
  title: string
  type: 'experience' | 'activity' | 'tour'
  typeLabel: string
}

interface EntertainmentPickerModalProps {
  isOpen: boolean
  onClose: () => void
  items: EntertainmentItem[]
  onSelect: (item: EntertainmentItem) => void
}

export const EntertainmentPickerModal: FC<EntertainmentPickerModalProps> = ({
  isOpen,
  onClose,
  items,
  onSelect,
}) => {
  const [search, setSearch] = useState('')
  const [filterType, setFilterType] = useState('all')

  if (!isOpen) return null

  const filteredItems = items.filter((item) => {
    const matchSearch = item.title.toLowerCase().includes(search.toLowerCase())
    const matchType = filterType === 'all' || item.type === filterType
    return matchSearch && matchType
  })

  // Cores e Ícones padronizados para cada tipo de entretenimento
  const getThemeConfig = (type: string) => {
    switch (type) {
      case 'experience':
        return {color: 'primary', icon: 'fas fa-star'}
      case 'activity':
        return {color: 'success', icon: 'fas fa-running'}
      case 'tour':
        return {color: 'warning', icon: 'fas fa-map-marked-alt'}
      default:
        return {color: 'secondary', icon: 'fas fa-box'}
    }
  }

  return (
    <BaseModal title='Vincular Entretenimento' onCloseAction={onClose} width='45rem' disableClose>
      {/* Filtros Fixos no Topo */}
      <div className='row g-5 mb-6 pt-6'>
        <div className='col-md-7 mt-0'>
          <Input
            label='Buscar por nome'
            inputAttr={{type: 'default'}}
            value={search}
            change={(val: string) => setSearch(val)}
            placeholder='Pesquise o entretenimento...'
            marginTop='0'
          />
        </div>
        <div className='col-md-5 mt-0'>
          <Input
            label='Filtrar por Tipo'
            inputAttr={{type: 'select'}}
            value={filterType}
            change={(val: string) => setFilterType(val)}
            options={[
              {value: 'all', select: 'Todos os tipos'},
              {value: 'experience', select: 'Experiências'},
              {value: 'activity', select: 'Atividades'},
              {value: 'tour', select: 'Passeios / Tours'},
            ]}
            marginTop='0'
          />
        </div>
      </div>

      {/* Lista de Resultados com Scroll */}
      <div className='pe-2' style={{overflowY: 'auto'}}>
        {filteredItems.length > 0 ? (
          <div className='d-flex flex-column gap-3'>
            {filteredItems.map((item, idx) => {
              const theme = getThemeConfig(item.type)

              return (
                <div
                  key={idx}
                  onClick={() => onSelect(item)}
                  className='d-flex align-items-center justify-content-between p-4 border border-dashed border-gray-300 rounded transition-base cursor-pointer bg-hover-light'
                >
                  <div className='d-flex align-items-center gap-4'>
                    {/* Ícone Contextual */}
                    <div className='symbol symbol-45px'>
                      <span className={`symbol-label bg-light-${theme.color}`}>
                        <i className={`${theme.icon} text-${theme.color} fs-4`}></i>
                      </span>
                    </div>

                    {/* Textos */}
                    <div className='d-flex flex-column'>
                      <span className='text-dark fw-bolder fs-6 mb-1'>{item.title}</span>
                      <span className='text-muted fw-bold fs-8 text-uppercase'>
                        {item.typeLabel}
                      </span>
                    </div>
                  </div>

                  {/* Ação */}
                  <button
                    type='button'
                    className='btn btn-sm btn-light btn-active-light-primary fw-bolder px-4 ms-2 flex-shrink-0'
                    onClick={(e) => {
                      e.stopPropagation() // Evita duplo clique
                      onSelect(item)
                    }}
                  >
                    Selecionar
                  </button>
                </div>
              )
            })}
          </div>
        ) : (
          /* Empty State (Estado Vazio) Elegante */
          <div className='text-center py-10 px-5'>
            <div
              className='bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4'
              style={{width: '80px', height: '80px'}}
            >
              <i className='fas fa-search fs-2x text-muted'></i>
            </div>
            <h4 className='fw-bolder text-dark mb-2'>Nenhum resultado encontrado</h4>
            <span className='text-muted fw-bold fs-6'>
              Tente buscar com outras palavras ou limpar o filtro de categoria.
            </span>
          </div>
        )}
      </div>
    </BaseModal>
  )
}
